import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useConnectorConsentTemplate } from 'modules/Meter/hooks';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Information from 'modules/Information';
import messages from '../../messages';
const Actions = ({ connectorConsentTemplate, onSetComponent, onCancel })=>{
    const legalConsentApprovals = connectorConsentTemplate.map((cct)=>({
            legalConsentId: cct.legalConsentId,
            decision: true
        }));
    const isInProgress = useSelector(Information.selectors.isUpdateInformationInProgress);
    const prevIsInProgressRef = useRef(isInProgress);
    const hasErrors = useSelector(Information.selectors.hasUpdateInformationErrors);
    const isLocked = isInProgress || !isInProgress && !hasErrors && prevIsInProgressRef.current;
    const onSubmit = useAction(Information.actions.updateInformation, {
        legalConsentApprovals
    });
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && !hasErrors) {
                onSetComponent('Initializing');
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__actions row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.cancel,
                    className: "btn--block",
                    isDisabled: isLocked,
                    onClick: onCancel
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.download,
                    className: "btn--block btn--filled",
                    isInProgress: isLocked,
                    onClick: onSubmit
                })
            })
        ]
    });
};
const Consent = ({ consentTemplate })=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const consentText = get(localizationResources, [
        consentTemplate.consentPromptKey,
        'value'
    ]);
    return /*#__PURE__*/ _jsx("p", {
        className: "brand__paragraph brand__fontSecondary",
        children: consentText
    });
};
const Consents = ({ connectorType, onSetComponent, onSetHeaderMessage, onCancel })=>{
    const connectorConsentTemplate = useConnectorConsentTemplate(connectorType);
    useEffect(()=>{
        onSetHeaderMessage(messages.headers.warningsBeforeDownloadData);
        return ()=>onSetHeaderMessage();
    }, []);
    useEffect(()=>{
        if (isEmpty(connectorConsentTemplate)) {
            onSetComponent('Initializing');
        }
    }, [
        connectorConsentTemplate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            connectorConsentTemplate.map((cct)=>/*#__PURE__*/ _jsx(Consent, {
                    consentTemplate: cct
                }, cct.legalConsentId)),
            /*#__PURE__*/ _jsx(Actions, {
                connectorConsentTemplate: connectorConsentTemplate,
                onSetComponent: onSetComponent,
                onCancel: onCancel
            })
        ]
    });
};
export default Consents;
